import { render, staticRenderFns } from "./manage-cat-names.vue?vue&type=template&id=05f8bfb1&"
import script from "./manage-cat-names.ts?vue&type=script&lang=ts&"
export * from "./manage-cat-names.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports